/**
 * Web Style Import
 *
 */

import './style/dnb-timeline.scss'
